.ux-iws-shop-lineitem {
    .ux-iws-shop-lineitem__price__crossprice,
    .ux-iws-shop-lineitem__price__crossprice-condition {
        text-align: right;
    }
}
